import axios from 'axios'
import store  from '@/store/index'
import ociUtils from '@/common/resources/ociUtils.js'

var userCodePrefix=  'OCI'+Math.random().toFixed(4).split('.')[1]

const Api = axios.create({
  baseURL: process.env.VUE_APP_API_BASE,
  //timeout: 10000,
  params: {} // do not remove this, its added to add params later in the config
});

// Add a request interceptor
Api.interceptors.request.use((request) => {
  // Do something before request is sent

  request.headers = {
    'Authorization': 'Bearer '+store.getters.userToken,
    'Oci-User': userCodePrefix+store.getters.appUser.userId,
    'Accept': ['application/json','image/png','application/pdf'],
    'Content-Type': 'application/json; charset=UTF-8',
    'Access-Control-Allow-Origin': process.env.VUE_APP_API_BASE,
    'Access-Control-Allow-Headers': 'X-PINGOTHER, Content-Type, Authorization, Content-Length, X-Requested-With,Oci-User',
    'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE, OPTIONS'
  };


  return request;
}, (error) => {

  // Do something with request error
  return Promise.reject(error);
});

// Add a response interceptor
Api.interceptors.response.use((response) => {
  // Do something with response data
  return response;
}, (error) => {
  // Do something with response error
  if(error.response.status === 401){
    window.location.replace("/auth/login");
    localStorage.removeItem("ocu");
   }
  return Promise.reject(error);
});


export default Api;

